import React, { useRef, useState, useEffect } from 'react';
import { EMAIL_DOMAIN_LIST } from '@common/constants';
import SatInput from '@components/common/satUI/SatInput';
import SatButton from '@components/common/satUI/SatButton';
import { CustomerInfoPreviousEmail } from '@container/customer';

const ChangeCustomerEmail = props => {
  const { emailAddr, onChange } = props;
  const inputEmailRef = useRef();
  const [searchVal, setSearchVal] = useState('');
  const [searchEmailList, setSearchEmailList] = useState([]);

  useEffect(() => {
    inputEmailRef.current.onFocus();
  }, []);

  useEffect(() => {
    if (emailAddr !== '' && emailAddr !== null) {
      setSearchVal(emailAddr);
    }
  }, [emailAddr]);

  const onSelectEmail = email => {
    setSearchVal(email);
  };

  const handleButtonClick = () => {
    onChange(searchVal);
  };

  const handleInput = value => {

    let afterValue = value.replace(/[^a-zA-Z0-9_.@-]/g, ''); //이메일 입력 폼(영문, 숫자, _.@-)만 허용
    
    value = afterValue;

    setSearchVal(value);

    if (value.includes('@')) {
      const emailArr = value.split('@');
      if (emailArr[1]) {
        const emailList = EMAIL_DOMAIN_LIST.filter(data =>
          data.includes(emailArr[1]),
        ).map(domain => {
          return `${emailArr[0]}@${domain}`;
        });

        setSearchEmailList(emailList);
      } else {
        const emailList = EMAIL_DOMAIN_LIST.map(domain => {
          return `${emailArr[0]}@${domain}`;
        });
        setSearchEmailList(emailList);
      }
    }
  };

  const EmailList = ({ email }) => {
    return (
      <li onClick={() => onSelectEmail(email)}>
        <span>{email}</span>
      </li>
    );
  };

  return (
    <React.Fragment>
      <div className="cont">
        <h3 className="layer-tit2">이메일 등록(수정)</h3>
        <SatInput
          ref={inputEmailRef}
          value={searchVal}
          type="email"
          label="이메일"
          onChange={handleInput}
          bold
        />
        <ul className="select-list2">
          {searchEmailList.map((email, index) => (
            <EmailList key={index} email={email} />
          ))}
        </ul>

        {/* Track2: 기등록 주소/기등록 이메일 기능 삭제 */}
        {/* <CustomerInfoPreviousEmail onSelect={setSearchVal} /> */}
      </div>

      <div className="layer-footer">
        <SatButton
          label={'확인'}
          styleClass="btn-s blue btn-wide"
          disabled={!$utils.checkEmail(searchVal)}
          onClick={() => handleButtonClick()}
        />
      </div>
    </React.Fragment>
  );
};

export default ChangeCustomerEmail;
